import { getJson } from "../../../api/http";
import { ClientDatabase } from "../types/db_management_types";
import client_db_mocks from "../../../mocks/client.database.mocks.json"

var test_mode = true; 
const API_BASE = (process.env.REACT_APP_API_URL ?? "").replace(/\/+$/, "");

const mock_client_databases: ClientDatabase[] = client_db_mocks as ClientDatabase[]

function build(path: string) {
  return path.startsWith("http") ? path : `${API_BASE}${path.startsWith("/") ? "" : "/"}${path}`;
}

export function fetchClientDatabases(signal?: AbortSignal): Promise<ClientDatabase[]> {
    if (test_mode==false)
        return getJson<ClientDatabase[]>(build("/api/ClientDatabases/Get"), { signal });
    else
        return Promise.resolve(mock_client_databases)
}
